import React, { useState, useEffect } from "react";
import {
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  Checkbox,
  Modal,
  Box,
  TextField,
  IconButton,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Sidebar from "./Sidebar"; // Import your Sidebar component
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SubAdminManagement = () => {
  const options = ["Make Admin"];
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const usersPerPage = 8; // Number of users per page

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setEmail("");
    setPassword("");
    setEmailError("");
    setPasswordError("");
  };

  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get("https://admin.yelospace.com/get-sub-admin", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data && response.data.response) {
        setUsers(response.data.response);
      } else {
        console.error("Error fetching users: Response data format incorrect");
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const createUser = async () => {
    let isValid = true;

    if (!email) {
      setEmailError("Email is required");
      isValid = false;
    } else if (!validateEmail(email)) {
      setEmailError("Invalid email format");
      isValid = false;
    } else {
      setEmailError("");
    }

    if (!password) {
      setPasswordError("Password is required");
      isValid = false;
    } else if (password.length < 4 || password.length > 15) {
      setPasswordError("Password must be between 4 and 15 characters");
      isValid = false;
    } else {
      setPasswordError("");
    }

    if (!isValid) return;

    try {
      const token = localStorage.getItem("token");
      await axios.post(
        "https://admin.yelospace.com/create-sub-admin",
        {
          email,
          password,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("User created successfully!");
      handleCloseModal();
      fetchUsers();
    } catch (error) {
      toast.error("Email already exists.");
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Calculate the range of users to display based on currentPage
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = users.slice(indexOfFirstUser, indexOfLastUser);

  return (
    <Container style={{ display: "flex", marginTop: "20px" }}>
      <Sidebar />
      <div style={{ flex: "1", marginLeft: "20vw" }}>
        <Typography
          variant="h6"
          style={{
            color: "#F5C000",
            fontWeight: "bold",
            marginBottom: "12px",
            marginTop: "24px",
          }}
        >
          SubAdmin Management
        </Typography>
        <Paper elevation={0} style={{ width: "100%", border: "1px solid #fee9c5" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px",
              borderBottom: "1px solid #F5C000",
            }}
          >
            <Typography variant="body1" component="p">
              Users ({users.length})
            </Typography>
            <div style={{ display: "flex" }}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#F5C000",
                  marginRight: "10px",
                  color: "#000",
                  borderRadius: "12px",
                  boxShadow: "none",
                }}
                onClick={handleOpenModal}
              >
                Create
              </Button>
            </div>
          </div>

          <TableContainer>
            <Table style={{ border: "1.5px solid #F5C000" }}>
              <TableHead>
                <TableRow style={{ borderBottom: "1.5px solid #F5C000" }}>
                  <TableCell></TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currentUsers.map((user) => (
                  <TableRow key={user.id} style={{ borderBottom: "1.5px solid #F5C000" }}>
                    <TableCell>
                      <Checkbox style={{ color: "#F5C000" }} />
                    </TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>{user.status}</TableCell>
                    <TableCell>
                      <IconButton aria-label="more">
                        <MoreVertIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
          {[...Array(Math.ceil(users.length / usersPerPage))].map((_, index) => (
            <Button
              key={index}
              variant="contained"
              style={{
                borderRadius: "20px",
                marginRight: "5px",
                backgroundColor: currentPage === index + 1 ? "#5F5F61" : "white",
                color: currentPage === index + 1 ? "white" : "#5F5F61",
              }}
              onClick={() => setCurrentPage(index + 1)}
            >
              {index + 1}
            </Button>
          ))}
        </div>
      </div>

      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            minWidth: 300,
            maxWidth: 500,
          }}
        >
          <Typography id="modal-title" variant="h6" component="h2">
            Create New User
          </Typography>
          <TextField
            id="email"
            label="Email"
            variant="outlined"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!emailError}
            helperText={emailError}
          />
          <TextField
            id="password"
            label="Password"
            type={showPassword ? "text" : "password"}
            variant="outlined"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={!!passwordError}
            helperText={passwordError}
            InputProps={{
              endAdornment: (
                <IconButton onClick={togglePasswordVisibility}>
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              ),
            }}
          />
          <Button
            variant="outlined"
            onClick={handleCloseModal}
            style={{ color: "#000", borderRadius: "12px", boxShadow: "none", border: "1px solid #F5C000", backgroundColor: "#F5C000" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{ color: "#000", borderRadius: "12px", boxShadow: "none", border: "1px solid #F5C000", backgroundColor: "#F5C000", marginLeft: "10px" }}
            onClick={createUser}
          >
            Create
          </Button>
        </Box>
      </Modal>

      <ToastContainer />
    </Container>
  );
};

export default SubAdminManagement;
